module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eLSz1h/tc-custom/9781442422186.jpg?1730534811086",
      "alt": "This image is the cover for the book Bubble Gum Rescue, Candy Fairies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bubble Gum Rescue, Candy Fairies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('b', [_vm._v("When gooey butterscotch endangers the inhabitants of Sugar Valley, it’s up to the Candy Fairies to come up with a sweet treat of a solution!")])]), _c('br'), _c('br'), _vm._v("While putting the finishing touches on her special caramel chocolate candies, Melli finds a small bird, his feathers coated in sticky butterscotch syrup. She learns from Cocoa that there’s a deep crack in the butterscotch volcano in the Caramel Hills, and gooey butterscotch is spilling everywhere, trapping small animals and endangering the sweet environment."), _c('br'), _vm._v("     How will the Candy Fairies protect the animals and their yummy homes from this candy catastrophe? By using pink, chewy bubble gum to plug up the crack and save the day, of course! The entire Candy Kingdom discovers that working together always makes life sweeter...and safer.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Perelman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Perelman has worked in a children’s bookstore and was a children’s book editor. She now writes full-time in New York, where she lives with her husband and two daughters. Visit her online at HelenPerelman.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0